// Export all Material Dashboard components
export { default as MDBox } from "./MDBox";
export { default as MDButton } from "./MDButton";
export { default as MDTypography } from "./MDTypography";
export { default as MDAvatar } from "./MDAvatar";
export { default as MDBadge } from "./MDBadge";
export { default as MDInput } from "./MDInput";
export { default as MDProgress } from "./MDProgress";
export { default as MDPagination } from "./MDPagination";
export { default as MDAlert } from "./MDAlert";

export function checkStrEmpty(str) {
    return !(str && str.length > 1 && str.split(' ').join('').length > 0)
}